import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { NgxEchartsModule } from 'ngx-echarts';
import { AssessmentReportModule } from '@app/main/analytics/assessment/assessment-report/assessment-report.module';
import { RouterModule } from '@angular/router';
import { LearnerReportComponent } from './learner-report/learner-report.component';
import { ProgramLauncherComponent } from './program-launcher/program-launcher.component';

const routes = [
  {
    path: 'player-view/courses/:courseId/sessions/:sessionId/report',
    component: LearnerReportComponent,
    data: { hideTopBar: true }
  },
  {
    path: 'player-view/programs/:programId/launcher',
    component: ProgramLauncherComponent,
    data: { hideTopBar: true }
  }
];

@NgModule({
  declarations: [
    LearnerReportComponent,
    ProgramLauncherComponent
  ],
  imports: [
    AssessmentReportModule,
    SharedModule,
    CommonModule,
    RouterModule.forRoot(routes),
    NgxEchartsModule.forChild(),
  ],
  exports: [
    LearnerReportComponent,
    ProgramLauncherComponent
  ]
})
export class PlayerViewModule { }
